import { useCallback, useRef, useEffect } from "react";
import { useLazyQuery as useLQ } from "@apollo/client";

export const useLazyQuery = ({ query, buildOptions, buildResult }) => {
  const [execute, result] = useLQ(query);
  const resolveRef = useRef();
  if (buildResult && result) {
    Object.assign(result, buildResult(result));
  }
  useEffect(() => {
    if (result.called && !result.loading && resolveRef.current) {
      resolveRef.current(result);
      resolveRef.current = undefined;
    }
  }, [result.loading, result.called, buildResult, result]);

  const queryLazily = useCallback(
    (config) => {
      let options = { ...config };
      if (buildOptions) {
        options = buildOptions(config);
      }
      execute(options);
      return new Promise((resolve) => {
        resolveRef.current = resolve;
      });
    },
    [buildOptions, execute]
  );

  return [queryLazily, result];
};
